import ENV from 'api/env';
// Types
import { TicketEventStatus } from 'api/graphql-global-types';
import { TicketEventListFields } from 'api/ticketing/types/TicketEventListFields';

const webUrl = (path: string): string =>
  `${ENV.REACT_APP_WEB_PORTAL_URL}${path}`;

export const getAffiliateLinkUrl = (code: string): string =>
  webUrl(`/a/${code}`);

export const getEventInviteUrl = (
  ticketEventId: string,
  invite: string
): string => webUrl(`/event-invite/${ticketEventId}/${invite}`);

export const getStreamInviteUrl = (streamId: string, invite: string): string =>
  webUrl(`/stream-invite/${streamId}/${invite}`);

/** The page fans see: the stream's page for a streamed event, none for a draft or a cancelled event. */
export const getEventPublicUrl = (
  event: Pick<
    TicketEventListFields,
    'status' | 'slug' | 'publishedAt' | 'stream'
  >
): string | null => {
  if (event.status === TicketEventStatus.Cancelled) {
    return null;
  }

  if (event.stream) {
    return event.stream.slug && event.stream.store?.slug
      ? webUrl(`/${event.stream.store.slug}/streams/${event.stream.slug}`)
      : null;
  }

  return event.publishedAt ? webUrl(`/events/${event.slug}`) : null;
};

export const getWatchInterviewUrl = (
  storeSlug: string,
  streamSlug: string
): string => webUrl(`/${storeSlug}/watch-stream/${streamSlug}`);
